import axios from "axios";
//vant 弹框
import store from "../store.js";
import Dialog from "vant/lib/dialog";
import Toast from "vant/lib/toast";
// import store from '../store.js'
import router from "../router/router.js";
import { domain } from "./api_config.js";

//qs 配合axios使用
import qs from "qs";
//import store from '../store.js';

// 配置默认域名，请求接口时自动添加域名
axios.defaults.baseURL = domain;
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
//axios.defaults.headers.common['Authorization'] = null;
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
};
// , axios.defaults.withCredentials = true;

// request interceptor
axios.interceptors.request.use(
  (config) => {
    let CompInfo = store.getters.getCompInfo;
    let MachineType = "cywpda";
    let _OperGID = null;
    let _CompGID = null;
    let _Authorization;
    let token;
    let admininfo = window.localStorage.getItem("adminInfo");
    if (admininfo == null || admininfo == "null") {
      (_CompGID = null), (_OperGID = null);
    } else {
      if (window.localStorage.getItem("_cyw_token")) {
        token = "Bearer " + window.localStorage.getItem("_cyw_token");
      }
      Toast.loading({
        mask: false,
        forbidClick: true,
        message: "加载中...",
        duration: 0,
      });
      _OperGID = JSON.parse(admininfo).GID;
      // 公司查询传递用户公司IGD
      if (config.url == "Company/Query") {
        _CompGID = JSON.parse(admininfo).CompGID;
      } else {
        _CompGID = CompInfo.CompGID;
      }
      _Authorization = token;
    }
    //config.headers['MachineType'] = 'cywpda';
    // if (window.localStorage.getItem('_cyw_token')) {
    //     config.headers['Authorization'] = token;
    // }
    //console.log(config)
    if (window.framework) {
      if (config.method === "post") {
        let data = qs.parse(config.data);
        config.data = qs.stringify({
          _OperGID,
          _CompGID,
          MachineType,
          _Authorization,
          ...data,
        });
      } else if (config.method === "get") {
        config.params = {
          _OperGID,
          _CompGID,
          MachineType,
          _Authorization,
          ...config.params,
        };
      }
    } else {
      if (config.method === "post") {
        let data = qs.parse(config.data);
        config.data = qs.stringify({
          _OperGID,
          _CompGID,
          _Authorization,
          ...data,
        });
      } else if (config.method === "get") {
        config.params = {
          _OperGID,
          _CompGID,
          _Authorization,
          ...config.params,
        };
      }
    }
    if (config.url == "https://wx.open.class.busboss.cn/Weixin/JSAPI") {
      config.params = {
        ...config.params,
      };
    }
    return config;
  },
  (error) => {
    //store.commit('hideLoading')
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);
axios.interceptors.response.use(
  (rsp) => {
    Toast.clear();
    rsp = rsp.data;
    if (Array.isArray(rsp)) {
      return rsp;
    }
    if (rsp.appId) {
      return rsp;
    }
    if (rsp.success === false) {
      //console.log('axios响应拦截器---请求成功但返回异常');
      //console.log(rsp.msg);
      let reemsg = "";
      let isAlert = true;
      if (rsp.msg.indexOf("Token已过期") != -1) {
        reemsg = "登录超时,请重新登录";
      }
      if (rsp.msg.indexOf("Token不匹配") != -1) {
        reemsg = "账号已在其他设备登录,请重新登录";
      }
      if (rsp.msg.indexOf("Ocr识别失败") != -1) {
        reemsg = "车牌号码识别失败";
      }
      if (rsp.msg.indexOf("已存在购票记录") != -1) {
        let errorObj = JSON.parse(rsp.msg)[0];
        // 未支付不弹窗直接跳转历史订单页面
        if (!errorObj.PaySuccessTime) {
          isAlert = false;
        } else {
          reemsg = errorObj.ErrorMsg;
        }
      }
      if (isAlert) {
        Dialog.alert({
          title: "提示",
          style: "z-index:9999",
          message: reemsg == "" ? rsp.msg : reemsg,
        }).then(() => {
          // 如果token 存在问题并且需要登录，就设置回调函数为退出，实现点击错误提示就自动退出
          if (
            rsp.msg.indexOf("Token") !== -1 &&
            rsp.msg.indexOf("登录") !== -1
          ) {
            //超时返回登录
            let user_name = window.localStorage.getItem("username");
            let user_pwd = window.localStorage.getItem("userpwd");
            window.localStorage.clear();
            window.localStorage.setItem("username", user_name);
            window.localStorage.setItem("userpwd", user_pwd);
            //跳转到登录
            router.push("/redirect");
          }
          Promise.reject(rsp);
        });
      }
    }
    return rsp;
  },
  (err) => {
    Toast.clear();
    Dialog.alert({
      title: "提示",
      message: err,
    }).then(() => {
      // on close
    });
  }
);

export default axios;
